import axios from "axios";

const apiHost = process.env.VUE_APP_LOCAL_MODE === "true" ? "" : (process.env.VUE_APP_APIURL || "");
let refreshPromise = null;

export function isLocalMode() {
  return process.env.VUE_APP_LOCAL_MODE === "true";
}

export function accessToken() {
  return localStorage.getItem("token") || localStorage.getItem("updateToken") || "";
}

export function clearLocalSession() {
  ["token", "updateToken", "localRefreshToken", "xcreateLocalRealmUser", "webTokens"].forEach((key) => localStorage.removeItem(key));
}

export function isJwtAuthorizationError(error) {
  return Number(error?.response?.status) === 401 && error?.response?.data?.isJwtError === true;
}

export async function refreshLocalSession() {
  if (!isLocalMode()) throw new Error("Local session refresh is unavailable outside local mode.");
  if (refreshPromise) return refreshPromise;
  const refreshToken = localStorage.getItem("localRefreshToken") || "";
  if (!refreshToken) {
    clearLocalSession();
    throw new Error("The local session has expired. Please sign in again.");
  }
  refreshPromise = axios.post(`${apiHost}/api/v1/local-auth/refresh`, {}, {
    headers: {Authorization: `Bearer ${refreshToken}`}
  }).then((response) => {
    if (!response.data?.status || !response.data?.token || !response.data?.refreshToken) throw new Error(response.data?.statusText || "Unable to refresh the local session.");
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("updateToken", response.data.token);
    localStorage.setItem("localRefreshToken", response.data.refreshToken);
    return response.data.token;
  }).catch((error) => {
    clearLocalSession();
    window.dispatchEvent(new CustomEvent("xcreate:session-expired"));
    throw error;
  }).finally(() => {
    refreshPromise = null;
  });
  return refreshPromise;
}
